import React from "react";
import SiteVisit from "../../dashboard/CRM/SiteVisit";
import {Grid} from '@material-ui/core'
import moment from 'moment-timezone'
import NotyBot from './img/notybotWelcome.png'
import {isNull, isUndefined} from 'lodash'
import {makeStyles} from '@material-ui/styles'

import { useSelector } from "react-redux";
import { injectIntl } from 'react-intl';

const useStyles =  makeStyles({
    notybot: {
      // 
      bottom: -9, 
      // left: '16%', 
      position: 'relative',
      height: 76, objectFit: 'contain', zIndex: 1
    },
    welcomeMessage:{
      paddingLeft:20
      // position: 'relative', zIndex: 2
    }
})

const WelComeCard = (props) => {
  const classes = useStyles()
  const Flags = useSelector(state => state.accountsData.Flags)

  const returnWelcomeMessage = () => {
    var now = new Date().getHours()

    console.log(now)

    if(5 <= now && now <= 9) return props.intl.formatMessage({ id: 'Massage.Good.Morning' })
    if(10 <= now && now <= 11) return props.intl.formatMessage({ id: 'Massage.Good.Morning1' })
    if(12 <= now && now <= 15) return props.intl.formatMessage({ id: 'Massage.Good.day' })
    if(16 <= now && now <= 18) return props.intl.formatMessage({ id: 'Massage.Good.afternoon' })
    if((19 <= now && now <= 23) || (0 <= now && now <= 4)) return props.intl.formatMessage({ id: 'Massage.Good.night' })
    else return ''
  }

  return (
    <Grid container className={'h-100 position-relative py-3'}>
        {
          isUndefined(Flags) ? '' :
          isNull(Flags.KontoLogo) ? '' : 
          <Grid item xs={12}>
            <div className="d-flex align-items-center justify-content-center w-100">
              <img  src={Flags.KontoLogo} alt="" style={{ objectFit: 'contain', maxHeight: 45, width: '100%'}} />
            </div>
          </Grid>
        }
        <Grid item xs={12}>
          <div className="d-flex w-100 h-100 align-items-center justify-content-around px-3">
            {/* <img className={classes.notybot} src={NotyBot} alt="" /> */}
            <div className="postition-relative d-flex align-items-center">
            <img className={classes.notybot} src={NotyBot} alt="" />
              <h2 className={"mb-0 text-center " + classes.welcomeMessage}>{returnWelcomeMessage() + ' ' + props.WelcomedUser}!</h2>
              {/* <h2 className={"mb-0 text-center " + classes.welcomeMessage}>{props.WelcomedUser}!</h2> */}
            </div>
            {/* <div>
            </div> */}
          </div>
        </Grid>
    </Grid>
  );
};

export default injectIntl(WelComeCard);
